import * as React from 'react';
import {FormattedMessage} from "react-intl";

import {useDeviceStore, selectIsMobile} from "features/ui/store/useDeviceStore";
import {ModalPosition, ModalType, useModal} from "features/modal/hooks/useModal";
import {getFilterCountResidenceExplorer} from "features/search/filters/helpers";
import {useResidenceExplorerStore, selectFilters} from "features/residenceExplorer/store/useResidenceExplorerStore";

import {Button, ButtonColor, ButtonSize, ButtonState, ButtonType} from "@atoms/LinksAndButtons/Button";

import {
    ResidenceExplorerMobileFilters
} from "features/residenceExplorer/components/ResidenceExplorerV2/_residenceExplorerMobileFilters";
import { ResidenceFilterModal } from 'components/modals/General/ResidenceFilterModal';
import { FilterFormType } from 'components/forms/ResidenceFilterForm';



export const ResidenceExplorerMobileFilterButton: React.FunctionComponent = ({}) => {
    const { open } = useModal();
    const [showFilters, _setShowFilters] = React.useState<boolean>(false);
    const filters = useResidenceExplorerStore(selectFilters);
    const isMobile = useDeviceStore(selectIsMobile);

    const { minRooms, maxRooms, minPrice, maxPrice, minArea, maxArea } = filters;

    const filterCount = getFilterCountResidenceExplorer({
        minArea: minArea,
        maxArea: maxArea,
        minPrice: minPrice,
        maxPrice: maxPrice,
        minRooms: minRooms,
        maxRooms: maxRooms,
    }, isMobile);

    const showMobileFilters = () => {
        open(
            <ResidenceFilterModal type={FilterFormType.RESIDENCE_EXPLORER} />,
            { 
                type: ModalType.FILTERS, 
                position: isMobile ? ModalPosition.RIGHT : ModalPosition.DEFAULT,
                fullscreen: false, 
                triggerElementId: 'filter-button', 
                noHash: true, 
            }
        );
    };

    return (
        <Button
            id="search-filter-button"
            onClick={showMobileFilters}
            foldableActive={filterCount > 0}
            buttonState={showFilters
                ? ButtonState.ACTIVE
                : ButtonState.DEFAULT
            } 
            buttonColor={ButtonColor.DEFAULT} 
            buttonSize={ButtonSize.DEFAULT} 
            buttonType={ButtonType.FOLD} 
        >
            {(filterCount > 0) ?
                <FormattedMessage id="jm.components.ResidenceFilters.filtersWithCount" values={{ filterCount: filterCount.toString() }} />  :
                <FormattedMessage id="jm.components.ResidenceFilters.filters" />
            }
        </Button>
    );
};
